import { IActionResult } from '~src/httpClient/serverApi/types/IActionResult';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ICreateBroadcastViewParams {
  viewId: string;
  overwrite?: boolean;
  showTabs?: boolean;
  showTableauBranding?: boolean;
}

export class CreateBroadcastViewRequest extends Request<ICreateBroadcastViewParams, IActionResult> {
  constructor(params: ICreateBroadcastViewParams) {
    super('putBroadcastView', params);
  }
}